// Dynamic shipping cards on product pages (snippets/pdp-delivery.liquid): rate, delivery dates and production country
// of the selected size for the chosen destination, from the per-size Gelato data file written weekly by the Gelato sync
// (supplyforge/aliffico-ops, scripts/gelato-sync). File shape: sizes.<key>.c.<ISO> = [rate USD, business days min, max,
// production ISO]; variants.<variant id> = <key>. Server-rendered text stays as the fallback if anything fails.
(() => {
  const root = document.querySelector('[data-pdp-ship]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-pdp-ship-config]').textContent);
  const visitor = root.dataset.country;
  const lang = document.documentElement.lang || 'en';
  const select = root.querySelector('[data-pdp-ship-country]');
  let data = null;
  let country = visitor;

  let names = null;
  try { names = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) { /* old browsers: ISO codes */ }
  const nameOf = (cc) => (names && names.of(cc)) || cc;
  // Locale article/preposition before a country name ("the United States", "au Canada"), same rules as pdp-local.liquid.
  const rules = cfg.prefix.split('|').map((r) => r.split(':'));
  const place = (cc) => {
    const rule = rules.find(([k]) => k === cc) || rules.find(([k]) => k === '*');
    return rule && rule[1] ? `${rule[1]} ${nameOf(cc)}` : nameOf(cc);
  };
  // Format like the store does for the visitor's currency: the theme passes 1234.56 rendered by the money filter
  // (e.g. "€1.234,56", "$1,234.56 USD"); separators and symbol are taken from it, Intl is the fallback.
  const money = (usd) => {
    const cur = window.Shopify && Shopify.currency;
    const code = (cur && cur.active) || 'USD';
    const amount = usd * ((cur && +cur.rate) || 1);
    const m = (cfg.moneySample || '').match(/1(\D?)234(\D)56/);
    if (m) {
      const [int, dec] = amount.toFixed(2).split('.');
      return cfg.moneySample.replace(m[0], int.replace(/\B(?=(\d{3})+(?!\d))/g, m[1]) + m[2] + dec);
    }
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: code }).format(amount); }
    catch (e) { return `US$${usd.toFixed(2)}`; }
  };
  const addBusinessDays = (n) => {
    const d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; }
    return d;
  };
  const dates = (min, max) => {
    let fmt;
    try { fmt = new Intl.DateTimeFormat(`${lang}-${country}`, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' }); }
    const from = addBusinessDays(min);
    const to = addBusinessDays(max);
    return (fmt.formatRange ? fmt.formatRange(from, to) : `${fmt.format(from)} – ${fmt.format(to)}`).replace(/[&<>]/g, '');
  };
  const span = (a, b) => (a === b ? `${a}` : `${a}–${b}`);
  const setAll = (sel, html) => document.querySelectorAll(sel).forEach((el) => { el.innerHTML = html; });

  const currentVariant = () => {
    const input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return (input && input.value) || new URLSearchParams(location.search).get('variant');
  };
  const rowFor = (variantId, cc) => {
    const key = data.variants[variantId];
    return key && data.sizes[key] ? data.sizes[key].c[cc] : undefined;
  };

  // Flag emoji from the ISO code (regional indicator symbols); Windows shows the two letters instead.
  const flag = (cc) => String.fromCodePoint(...[...cc].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
  const fillCountries = (variantId) => {
    const key = data.variants[variantId];
    const codes = new Set(key && data.sizes[key] ? Object.keys(data.sizes[key].c) : []);
    codes.add(visitor);
    codes.add(country);
    const sorted = [...codes].sort((a, b) => nameOf(a).localeCompare(nameOf(b), lang));
    select.innerHTML = sorted.map((cc) => `<option value="${cc}"${cc === country ? ' selected' : ''}>${flag(cc)} ${nameOf(cc)}</option>`).join('');
  };

  // Only the visitor's own country decides whether the size can be bought; other destinations are a preview.
  const gate = (variantId) => {
    const form = document.querySelector('product-form');
    const button = form && form.querySelector('[name="add"]');
    if (!button) return;
    const pay = form.querySelector('.shopify-payment-button');
    if (rowFor(variantId, visitor)) {
      if (pay) pay.style.display = '';
      return;
    }
    const text = cfg.na.replace('__C__', place(visitor));
    if (typeof form.toggleSubmitButton === 'function') form.toggleSubmitButton(true, text);
    else button.disabled = true;
    if (pay) pay.style.display = 'none';
  };

  const render = (variantId) => {
    // Variants the sync hasn't seen yet (just published) keep the server-rendered cards and a working button.
    if (!data || !variantId || !data.variants[variantId]) return;
    fillCountries(variantId);
    const row = rowFor(variantId, country);
    const cards = root.querySelector('[data-pdp-ship-cards]');
    const na = root.querySelector('[data-pdp-ship-na]');
    if (!row) {
      const text = cfg.na.replace('__C__', place(country));
      cards.hidden = true;
      na.hidden = false;
      na.querySelector('[data-pdp-ship-na-text]').textContent = text;
      setAll('[data-pdp-ship-spec]', text);
      setAll('[data-pdp-ship-tab]', `${text}.`);
    } else {
      const [usd, min, max, made] = row;
      const n = span(min, max);
      cards.hidden = false;
      na.hidden = true;
      root.querySelector('[data-pdp-ship-price]').textContent = money(usd);
      root.querySelector('[data-pdp-ship-dates]').textContent = dates(min, max);
      root.querySelector('[data-pdp-ship-days]').textContent = `${n} ${cfg.bdays}`;
      setAll('[data-pdp-ship-spec]', cfg.spec.replace('__N__', n));
      const line = cfg.price.replace('__C__', place(country)).replace('__P__', money(usd));
      setAll('[data-pdp-ship-tab]', `${line}. ${cfg.tab.replace('__N__', n)} ${cfg.tabRate}`);
      // Production country: never named for generic destinations (US, owner decision); "close to you" when local.
      const prod = !cfg.generic.includes(country) && cfg.in[made]
        ? `<strong>${(made === country ? cfg.printedLocal : cfg.printed).replace('__I__', cfg.in[made])}</strong>`
        : cfg.genericProd;
      setAll('[data-pdp-ship-prod]', prod);
    }
    gate(variantId);
  };

  select.addEventListener('change', () => { country = select.value; render(currentVariant()); });
  fetch(root.dataset.file)
    .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
    .then((json) => {
      data = json;
      render(currentVariant());
      // PUB_SUB_EVENTS is a top-level const in constants.js, so it is not a window property.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => render(String(event.data.variant ? event.data.variant.id : currentVariant())));
      }
    })
    .catch(() => { /* keep the server-rendered text */ });
})();
